import { createStore } from 'vuex'

export default createStore({
  state: {
    email:null,
    token:null,
    expire:null,
    fullname:null,
    theme_dark:true
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})